module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/ahead8-61411967558608851e274072963205c2.jpg";